import React from "react";
import classNames from "classnames";

import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import MinusIcon from "@material-ui/icons/Remove";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    backgroundColor: "#ffffff",
    border: "1px solid #D0DBDF",
    borderRadius: 8,
    overflow: "hidden"
  },
  button: {
    borderRadius: 0,
    width: 40,
    height: 36,
    padding: 0,
    color: "#4a5563",
    backgroundColor: "#ffffff"
  },
  divider: {
    width: 1,
    flexShrink: 0,
    height: "80%",
    minHeight: 24,
    backgroundColor: "#D0DBDF",
    alignSelf: "center"
  },
  quantityWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    textAlign: "center",
    backgroundColor: "#ffffff",
    border: "none",
    width: 40,
    height: 36,
    fontSize: 16,
    fontWeight: 600,
    color: "#1f2937",
    padding: 0,
    "&[type=number]": {
      MozAppearance: "textfield"
    }
  }
}));

type Props = {
  quantity: number;
  setQuantity: (quantity: number) => void;
  className: string;
};

export default function QuantitySelector({
  quantity,
  setQuantity,
  className
}: Props) {
  const styles = useStyles();
  return (
    <div className={classNames(styles.wrapper, className)}>
      <IconButton
        onClick={() => setQuantity(Math.max(quantity - 1, 0))}
        disableRipple
        size="small"
        className={styles.button}
      >
        {quantity === 1 ? (
          <DeleteOutlineOutlinedIcon fontSize="small" />
        ) : (
          <MinusIcon fontSize="small" />
        )}
      </IconButton>
      <div className={styles.divider} aria-hidden />
      <input
        className={styles.quantityWrapper}
        value={quantity.toString()}
        type="number"
        inputMode="numeric"
        min="0"
        onChange={(e) => setQuantity(Number(e.currentTarget.value))}
      />
      <div className={styles.divider} aria-hidden />
      <IconButton
        onClick={() => setQuantity(quantity + 1)}
        disableRipple
        size="small"
        className={styles.button}
      >
        <AddIcon fontSize="medium" />
      </IconButton>
    </div>
  );
}
